import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement, useState } from 'react'
import styled from 'styled-components'
import Map from 'components/Map'
import List from 'components/List'

import './Main.scss'
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'


const MainComponent: FC<MicroFrontendProps> = (props): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts
  ]
  const [latLng, setLatLng] = useState<number[] | null>(null)
  const showLocation = (lat: number, lng: number) => {
    setLatLng([lat, lng])
  }
  return (
    <AppContainer className='container'>
      <List handleShow={showLocation} />
      <Map preselectedZoom={props.properties?.zoom} panTo={latLng} />
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`
  width: 100%;
  margin: 0;
  margin-bottom: 2em;
  // font-family: var(--font-sans-serif);
  font-family: 'IBM Plex Sans';
  font-size: 1.6em;
`
export default MainComponent
